var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('router-link',{attrs:{"to":"/offers"}},[_vm._v(_vm._s(_vm.$t("Job offers"))+" "),(_vm.numberOfTotalUnseenJobOfferInterests > 0)?_c('b-badge',{attrs:{"pill":"","variant":"danger"}},[_vm._v(_vm._s(_vm.numberOfTotalUnseenJobOfferInterests))]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }